export default "__VITE_ASSET__OUgtU7KN__"